import { useState } from "react";
import { IconClose, IconSearch } from "../../icons";
import { Container } from "./styles";

interface FilterProps {
    searchTerm?: string;
    setSearchTerm?: (value: string) => void;
}

export default function PlanosFilter({ searchTerm, setSearchTerm }: FilterProps) {
    const [DTOSearch, setDTOSearch] = useState<string>(searchTerm || '');

    function handleOnChanges(value: string) {
        setDTOSearch(value);
        setSearchTerm?.(value);
    }

    function clearSearch() {
        setDTOSearch('');
        setSearchTerm?.('');
    }

    function searchKeyPressed(event: React.KeyboardEvent) {
        if (event.key === 'Enter') {
            setSearchTerm?.(DTOSearch);
        }
    }

    return (
        <Container>
            <div className="search">
                <div className="buscar" onClick={() => setSearchTerm?.(DTOSearch)}>
                    <IconSearch />
                </div>
                <input
                    placeholder="Pesquisar planos"
                    onChange={(e) => handleOnChanges(e.target.value)}
                    onKeyDown={searchKeyPressed}
                    value={DTOSearch}
                />
                {DTOSearch && (
                    <div className="clean-search" onClick={clearSearch}>
                        <IconClose />
                    </div>
                )}
            </div>
        </Container>
    );
}
